export const state = {
  addUserNotification: {
    title: '',
    message: ''
  },
  updateUserNotification: {},
  userNotification: {},
  userNotifications: [],
  total: 0,
  selectedUserNotificationList: [],
  posts: [],
  selectedposts: []
}
export const mutations = {
  setUserNotifications(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
      state.total = 0
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      if (
        state.selectedUserNotificationList.some(
          selectedUserNotification =>
            selectedUserNotification.id === response.data['data'][i]['id']
        )
      ) {
        response.data['data'][i]['checked'] = true
      } else {
        response.data['data'][i]['checked'] = false
      }
    }
    state.userNotifications = response.data['data']
    state.total = response.data['header']['total']
  },
  setDetail(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = ''
    }
    state.userNotification = response.data['data']
    state.updateUserNotification = {}
    state.updateUserNotification.id = state.userNotification.id
    state.updateUserNotification.title = state.userNotification.title
    state.updateUserNotification.message = state.userNotification.message
    state.updateUserNotification.allFlag = state.userNotification.allFlag
    state.updateUserNotification.postIdList = state.userNotification.postList.map(
      post => post.postId
    )
    state.updateUserNotification.startDateTime =
      state.userNotification.startDateTime
    state.updateUserNotification.endDateTime =
      state.userNotification.endDateTime
  },
  inputUpdate(state, payload) {
    state.updateUserNotification[payload.name] = payload.value
  },
  inputAddUpdate(state, payload) {
    state.addUserNotification[payload.name] = payload.value
  },
  clearUserNotification(state) {
    state.addUserNotification = {}
  },
  updateSelectedUserNotificationList(state, payload) {
    for (var i = 0; i < payload.length; i++) {
      if (
        payload[i].checked &&
        !state.selectedUserNotificationList.some(
          UserNotification => UserNotification.id === payload[i].id
        )
      ) {
        state.selectedUserNotificationList.push(payload[i])
      } else if (
        !payload[i].checked &&
        state.selectedUserNotificationList.some(
          UserNotification => UserNotification.id === payload[i].id
        )
      ) {
        const deleteIndex = state.selectedUserNotificationList.findIndex(
          UserNotification => UserNotification.id === payload[i].id
        )
        state.selectedUserNotificationList = state.selectedUserNotificationList.toSpliced(
          deleteIndex,
          1
        )
      }
    }
  },
  clearSelectedUserNotificationList(state) {
    state.selectedUserNotificationList = []
  },
  setPosts(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      response.data['data'][i]['checked'] = false
    }
    state.posts = response.data['data']
  },
  setSelectedPosts(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      response.data['data'][i]['checked'] = false
    }
    state.selectedposts = response.data['data']
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/userNotificationModules/userNotificationMutation.js